import React from 'react'
import { QuestionMarkOutlineIcon } from '@mote/assets/icons'
import { isNumber, omit } from '@mote/helpers'
import { __DEV__ } from '@mote/helpers/constants'
import styled, { css, th } from '@xstyled/styled-components'
import { Button } from './button'

export const IconButton = React.forwardRef((props, ref) => {
  const normalizedProps = omit(props, [
    'text',
    'loadingText',
    'block',
    'autoWidth',
    'iconPosition'
  ])

  return <Root ref={ref} variant='soft' pill={true} {...normalizedProps} />
})

if (__DEV__) {
  IconButton.displayName = 'IconButton'
}

export const InfoIconButton = React.forwardRef((props, ref) => {
  return (
    <InfoIconButtonRoot
      ref={ref}
      icon={<QuestionMarkOutlineIcon />}
      {...props}
    />
  )
})

if (__DEV__) {
  InfoIconButton.displayName = 'InfoIconButton'
}

const Root = styled(Button)`
  padding: 0;

  ${({ size }) => {
    if (isNumber(size)) {
      return css`
        width: ${size}px;
        height: ${size}px;
      `
    }
  }}
`

const InfoIconButtonRoot = styled(IconButton)`
  & span.button-icon {
    color: ${th.color('grey.d1')};
  }
`
